export default "__VITE_ASSET__1gHZ0T4$__"